import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MachineTimeline from './MachineTimeline';

//for machine


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        height: '400'
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
}));

const MachineTimelineList = ({ data, selectedMachines }) => {

    const classes = useStyles();

    return (
        // 6/19/2024 setting the default to 10 b/c when F5 is pressed the list of timelines condenses to 1 line.
        <MachineTimeline machineNames={selectedMachines} displayRowLabels={true} defaultTimelineHeight={10}/>
    );
}
export default MachineTimelineList